module.exports = __webpack_public_path__ + "static/media/call_refuse.2e78c6db.png";